(() => {
  if (window.SpoiltSaleReady) return;
  window.SpoiltSaleReady = true;
  const config = document.querySelector('[data-sale-runtime]');
  const page = document.querySelector('[data-sale-page]');
  const indexPath = page?.dataset.indexPath || config?.dataset.indexPath;
  if (!indexPath) return;
  let items = [];
  const percent = value => Math.round(value * 10) / 10;
  function updateBadges(products) {
    const max = products.reduce((value, product) => Math.max(value, product.discount), 0);
    document.querySelectorAll('[data-sale-badge]').forEach(badge => {
      badge.textContent = max > 0 ? `Up to ${percent(max)}%` : '';
      badge.hidden = max <= 0;
      if (max > 0) badge.style.removeProperty('display');else badge.style.display = 'none';
    });
  }
  async function load(withCards) {
    const found = [], seen = new Set();
    const view = withCards ? 'spoilt-sale-cards' : 'spoilt-sale-data';
    let url = new URL(indexPath, location.origin);
    url.searchParams.set('view', view);
    while (url) {
      if (seen.has(url.href)) throw new Error('Repeated catalog page');
      seen.add(url.href);
      const response = await fetch(url.href, {credentials: 'same-origin'});
      if (!response.ok) throw new Error('Sale catalog unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const root = doc.querySelector('[data-sale-index]');
      if (!root) throw new Error('Sale index unavailable');
      doc.querySelectorAll('[data-sale-product]').forEach(template => {
        const discount = Number(template.dataset.discount);
        if (discount > 0) found.push({...template.dataset, discount, html: template.innerHTML});
      });
      url = root.dataset.next ? new URL(root.dataset.next, location.origin) : null;
      if (url) url.searchParams.set('view', view);
    }
    return found.sort((a, b) => b.discount - a.discount || a.handle.localeCompare(b.handle));
  }
  function card(product) {
    const template = document.createElement('template');
    template.innerHTML = product.html;
    const price = template.content.querySelector('.custom-product-price');
    if (price) price.textContent = product.price;
    const priceWrapper = template.content.querySelector('.custom-product-price-wrapper');
    if (priceWrapper) {
      let group = priceWrapper.querySelector('.custom-compare-price-group');
      if (!group) {group = document.createElement('div');group.className = 'custom-compare-price-group';priceWrapper.append(group);}
      const compare = document.createElement('span');compare.className = 'custom-product-compare-price';compare.textContent = product.compare;
      const badge = document.createElement('span');badge.className = 'custom-discount-badge';badge.textContent = `-${percent(product.discount)}%`;
      group.replaceChildren(compare, badge);
    }
    const link = template.content.querySelector('a.custom-product-card');
    if (link) {const url = new URL(link.href, location.origin);url.searchParams.set('variant', product.variant);link.href = url.pathname + url.search;}
    return template.content;
  }
  const valuesFor = (item, name) => {
    if (name === 'filter.p.vendor') return [item.vendor];
    if (name === 'filter.p.tag') return JSON.parse(item.tags || '[]');
    if (name === 'filter.p.m.custom.grade_name') return [item.grade];
    if (name === 'filter.p.m.custom.stock') return [item.stock];
    if (name === 'filter.v.t.shopify.color-pattern') return (item.colors || '').match(/gid:\/\/shopify\/TaxonomyValue\/\d+/g) || [];
    return [];
  };
  function matchesFilters(item, params, ignore) {
    for (const name of new Set(params.keys())) {
      if (!name.startsWith('filter.') || name === ignore) continue;
      const selected = params.getAll(name).filter(Boolean);if (!selected.length) continue;
      if (name === 'filter.v.price.gte') {if (Number(item.amount) < Number(selected[0])) return false;}
      else if (name === 'filter.v.price.lte') {if (Number(item.amount) > Number(selected[0])) return false;}
      else if (!selected.some(value => valuesFor(item, name).includes(value))) return false;
    }
    return true;
  }
  function syncFilters(params, pool, count) {
    const aside = page.querySelector('[data-sale-filters]');if (!aside) return;
    aside.querySelectorAll('input[type="checkbox"][name]').forEach(input => {
      input.checked=params.getAll(input.name).includes(input.value);
      input.disabled=!input.checked && !pool.some(item=>matchesFilters(item,params,input.name)&&valuesFor(item,input.name).includes(input.value));
      input.closest('label')?.classList.toggle('disabled',input.disabled);
      input.closest('label')?.classList.toggle('active',input.checked);
    });
    aside.querySelectorAll('input[name^="filter.v.price"]').forEach(input=>input.value=params.get(input.name)||'');
    aside.querySelectorAll('price-range').forEach(range=>{range.setMinAndMaxValues?.();range.syncSlidersFromInputs?.();});
    aside.querySelectorAll('#ProductCount, #ProductCountDesktop, .mobile-facets__count').forEach(el=>{el.textContent=count+' products';el.classList.remove('loading');});
    aside.querySelectorAll('.loading__spinner').forEach(el=>el.classList.add('hidden'));
    aside.querySelectorAll('facet-remove a').forEach(link=>{
      const next=new URLSearchParams(params);
      for(const name of [...next.keys()]) if(name.startsWith('filter.'))next.delete(name);
      next.delete('sale_page');link.href=location.pathname+'?'+next;link.classList.remove('disabled');
    });
    aside.querySelectorAll('.active-facets__button').forEach(el=>el.parentElement.remove());
  }
  function render() {
    const params = new URLSearchParams(location.search);
    const pool = items;
    const filtered = pool.filter(item=>matchesFilters(item,params));
    syncFilters(params,pool,filtered.length);
    const pages = Math.max(1, Math.ceil(filtered.length / 24));
    const current = Math.min(pages, Math.max(1, parseInt(params.get('sale_page'), 10) || 1));
    const grid = page.querySelector('[data-sale-grid]');
    grid.replaceChildren(...filtered.slice((current - 1) * 24, current * 24).map(card));
    grid.setAttribute('aria-busy', 'false');
    page.querySelector('[data-sale-status]').textContent = `${filtered.length} discounted ${filtered.length === 1 ? 'product' : 'products'}`;
    const nav = page.querySelector('[data-sale-pages]');nav.replaceChildren();
    if (pages > 1) for (let number = 1; number <= pages; number++) {
      const link = document.createElement('a');const url = new URL(location.href);url.searchParams.set('sale_page', number);
      link.href = url.pathname + url.search;link.textContent = number;link.dataset.salePageLink = '';
      if (number === current) link.setAttribute('aria-current', 'page');nav.append(link);
    }
  }
  async function start() {
    try {items = await load(Boolean(page));updateBadges(items);if (page) render();}
    catch {
      if (!page) return;
      page.querySelector('[data-sale-grid]').setAttribute('aria-busy', 'false');
      const status = page.querySelector('[data-sale-status]');status.textContent = 'Could not load current offers. ';
      const retry = document.createElement('button');retry.type = 'button';retry.textContent = 'Try again';retry.addEventListener('click', start, {once:true});status.append(retry);
    }
  }
  if (page) {
    window.SpoiltSaleFilters={render(searchParams,event,updateHistory=true){
      if(!updateHistory){render();return;}
      const params=new URLSearchParams(searchParams);
      params.set('view','sale');params.delete('sale_gender');params.delete('sort_by');params.delete('sale_page');
      history.pushState({searchParams:params.toString()},'',location.pathname+'?'+params);render();
    }};
    page.addEventListener('click', event => {
      const link = event.target.closest('[data-sale-page-link]');if (!link) return;
      event.preventDefault();history.pushState({}, '', link.href);render();page.scrollIntoView({block:'start'});
    });
    window.addEventListener('popstate', render);
    start();
  } else {
    if ('requestIdleCallback' in window) requestIdleCallback(start, {timeout:1500});else setTimeout(start, 300);
  }
})();



